module.exports = __webpack_public_path__ + "static/img/image030.4ddeebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image030.png
// module id = gqER
// module chunks = 1